/**
 * Vehicle status (`VEH_SITUATION`) — the only source of the displayed status
 * (fiches 22756 / 22809): « EN COURS » → green-dot « En cours », « SORTI » →
 * red-dot « Sorti » (design). Values are matched normalised (trimmed — VEOS
 * returns `" EN COURS"` on FIC_VEH —, upper-cased, accents stripped); any
 * other value is shown verbatim.
 */

import { normaliseStatus, type StatusBadgeConfig } from '../shared/statusBadgeConfig';

/** Raw `VEH_SITUATION` values. */
export const VEHICLE_SITUATION = {
  active: 'EN COURS',
  out: 'SORTI',
} as const;

export const VEHICLE_STATUS_BADGE: StatusBadgeConfig = {
  entries: {
    [VEHICLE_SITUATION.active]: { label: 'En cours', variant: 'success' },
    [VEHICLE_SITUATION.out]: { label: 'Sorti', variant: 'error' },
  },
  dot: true,
  fallbackVariant: 'default',
};

/** Active / exited vehicle counts of a fleet (from `VEH_SITUATION`). */
export interface FleetCounts {
  active: number;
  out: number;
}

export function countFleetVehicles(
  vehicles: ReadonlyArray<{ statut: string | null }>,
): FleetCounts {
  const counts: FleetCounts = { active: 0, out: 0 };
  for (const vehicle of vehicles) {
    if (vehicle.statut === null) continue;
    const status = normaliseStatus(vehicle.statut);
    if (status === VEHICLE_SITUATION.active) counts.active += 1;
    else if (status === VEHICLE_SITUATION.out) counts.out += 1;
  }
  return counts;
}
